import { createFromIconfontCN } from '@ant-design/icons'
const IconFont = createFromIconfontCN({
  scriptUrl: 'https://at.alicdn.com/t/font_2476093_g6yjm48ayvs.js'
})
export default IconFont
